export const cacheStatusTypes = {
    DONE: 'done',
    IN_PROGRESS: 'in_progress',
};

export const cacheResultTypes = {
    COMPLETE: 'complete',
    ERROR: 'error',
    INCOMPLETE: 'incomplete',
    SKIPPED: 'skipped',
    TIMEOUT: 'timeout',
};

const cacheStatusActions = {
    types: {
        CACHE_STATUS_SET: 'CACHE_STATUS_SET',
        CACHE_STATUS_ITEM_FAILED: 'CACHE_STATUS_ITEM_FAILED',
        CACHE_LOAD_PROGRESS_SET: 'CACHE_LOAD_PROGRESS_SET',
    },

    setStatus(identifier, status, result) {
        return {
            identifier,
            result,
            status,
            type: this.types.CACHE_STATUS_SET,
        };
    },

    setLoadProgress(identifier, totalLoaded, combinedSize, lastUpdatedTime, startTime, hasFailed) {
        return {
            identifier,
            totalLoaded,
            combinedSize,
            lastUpdatedTime,
            startTime,
            hasFailed,
            type: this.types.CACHE_LOAD_PROGRESS_SET,
        };
    },

    setItemFailed(identifier) {
        return {
            identifier,
            type: this.types.CACHE_STATUS_ITEM_FAILED,
        };
    },
};

export default cacheStatusActions;
